import React from "react";
import styled from "styled-components";
import { ColorModel } from "../models";
import {
  FlexContainer,
  Input,
  InputColorBlock,
  ColorPicker as ColorPickerComponent,
} from "@mindmemobile/mm-shared-global";

const InputColorBlockWrapper = styled.div`
  position: relative;
  .color-outer-input {
    border: 1px solid #aaa;
    border-radius: 4px;
    position: relative;
    height: 42px;
    input {
      border: 0;
    }
  }
  .attribute-color-picker {
    position: absolute;
    top: 0px;
    left: 0px;
    right: auto;
    transform: translate(0px, 45px);
    z-index: 9999;
  }
  .input-with-block {
    width: 160px;
  }
`;

type IProps = {
  onClick: () => void;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showColorPicker: boolean;
  color: ColorModel;
  onHideColorPicker: () => void;
  onColorChange: (color: ColorModel) => void;
  showColorBlock?: boolean;
};

const InputWithColorBox: React.FC<IProps> = ({
  value,
  onClick,
  onChange,
  showColorPicker,
  color,
  onHideColorPicker,
  onColorChange,
  showColorBlock,
}) => {
  return (
    <InputColorBlockWrapper>
      {" "}
      <FlexContainer className="color-outer-input">
        <Input
          id={`txt_optonname_`}
          value={value}
          type="text"
          onChange={(e) => onChange(e)}
          className={`styled-input ${showColorBlock ? "input-with-block" : "input-without-block"}`}
        />
        {showColorBlock && (
          <InputColorBlock bgColor={color.rgba} onClick={() => onClick()} />
        )}
      </FlexContainer>
      {showColorPicker && (
        <ColorPickerComponent
          color={ColorModel.createAPIModel(color)}
          onChange={(newColor) =>
            onColorChange(ColorModel.deserializeAPIModel(newColor))
          }
          onHide={() => onHideColorPicker()}
          className="attribute-color-picker"
        />
      )}
    </InputColorBlockWrapper>
  );
};

export default InputWithColorBox;
